import React, { useCallback, useState } from 'react';

import styled from 'styled-components';

import { useBrazeContext } from 'state/braze';

import { StyledContentCardContainer } from './styled';
import { IContentCardsProps } from './types';

const ContentCardContainer = styled.div`
  ${Styles.desktop`
    margin-top: 120px;
  `}
`;

const Header = styled.h2`
  color: ${Styles.color.black};
  font-size: 1.1rem;
  text-align: center;
  margin: 0;
  padding: 0;
  margin-bottom: 1rem;
  ${Styles.desktop`
    font-size: 2rem;
`}
`;

const SubHeader = styled.h3`
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 1.4rem;
  color: ${Styles.color.tertiary};
  letter-spacing: -2px;
  line-height: 90%;
  margin: 0;
  text-shadow: none;
  transform-origin: bottom;
  transform: rotate(-5deg) translateY(-10%);
  text-align: center;
  ${Styles.desktop`
    font-size: 2.7rem;
  `}
`;

const ContentCards: React.FC<IContentCardsProps> = ({ item: headersText }) => {
  const [displayed, setDisplayed] = useState(false);
  const { contentCardsHeader, contentCardsSubheader } = headersText ?? {};
  const heading = contentCardsHeader?.locale;
  const subheading = contentCardsSubheader?.locale;
  const braze = useBrazeContext();

  const showCardSection = braze.getCachedContentCards() && braze.getCachedContentCards().length > 0;

  const containerRef = useCallback(
    (container: HTMLDivElement | null) => {
      if (!displayed && container) {
        braze.toggleContentCards(container);
        setDisplayed(true);
      }
    },
    [braze, displayed]
  );

  return showCardSection ? (
    <ContentCardContainer>
      <SubHeader>{heading}</SubHeader>
      <Header>{subheading}</Header>
      <StyledContentCardContainer ref={containerRef} />
    </ContentCardContainer>
  ) : null;
};

export default ContentCards;
